<template>
  <div
    ref="cont"
    class="tableddfiles position-relative text-noselect flex-1"
  >
    <div
      class="f-align-center w-100 no-scroll-track"
      style="overflow: auto"
    >
      <div class="text-large my-auto f-center weight_700 text-nowrap">
        {{ $t('data_table.practice_sessions.title') }}
      </div>
      <!-- <GwSavedFiltersMenu
        class="ml-2"
        filterUrlPrefix="ffps"
      /> -->
    </div>

    <GwFilter
      v-if="!tcrud_trulySelectedItems.length"
      class="mt-2"
      :asRow="true"
      :hasSaveBtn="false"
      :hasClearBtn="false"
      filterUrlPrefix="ffps"
      filterConfigKey="practiceSessions"
    />
    <TableDeleteBtns
      v-else
      class="mt-2"
      @confirm="tcrud_batchDeleteSelectedItems"
      @close="tcrud_resetSelectedRows()"
    />

    <TableBody
      class="hhhtable gw_table_small flex-1 mt-2"
      :items="tcrud_items"
      :loading="tcrud_loading"
      :error="tcrud_error"
    >
      <template #no_data>
        <div
          class="gw_box flex-1 f-center f-column anim-fade-in"
          style="--clr-box-back: var(--clr-black-0-3)"
        >
          <IconAndText
            v-if="filter.active"
            icon="mdi-filter"
            :title="$t('data_table.practice_sessions.no_data')"
            :subtitle="$t('data_table.practice_sessions.no_data_change_filter_tra01')"
          />
          <IconAndText
            v-else
            icon="mdi-cards-variant"
            :title="$t('data_table.practice_sessions.no_data')"
            :subtitle="$t('data_table.practice_sessions.play_trainer')"
          />
          <router-link
            v-if="!filter.active"
            class="gw_btn-v1 gw_btn_primary mt-4 clr-white"
            :to="{ name: 'PracticeTrainer' }"
            @click.stop="
              $store.dispatch('globals_drawer_toggle', {
                id: 'upload-boxes',
              })
            "
          >
            <i class="mdi mdi-play text-semi-large mr-1"></i>
            {{ $t('common.play_against_gto') }}
          </router-link>
        </div>
      </template>
      <template #head_before>
        <TableHead
          :sortConf="tbl_sortConf"
          :thead="thead"
          @click:th="tbl_handleSort"
        >
          <template #th_before>
            <TableHeadCell
              class="f-center"
              style="
                --max-width-th: 4rem;
                --min-width-th: 4rem;
                --padding-th: 0;
                --overflow-th: none;
                border-top-left-radius: 4px;
              "
            >
              <div
                class="d-flex"
                style="gap: 0.5rem"
              >
                <TableMainCheckbox
                  style="font-size: 1rem"
                  :indeterminate="tcrud_mainCheckboxValue === 'indeterminate'"
                  :value="tcrud_mainCheckboxValue === 'all'"
                  @click="tcrud_toggleSelectedAll"
                />

                <TableFilterStar
                  :value="(filter.params || {}).marked === 'true'"
                  @click="tcrud_resetSelectedRows()"
                  @input="val => $router.replace({ query: { ...$route.query, ffps_marked: val } })"
                />
              </div>
            </TableHeadCell>
          </template>
          <template #th_after>
            <TableHeadCell
              class="f-center"
              style="--max-width-th: 3rem"
            ></TableHeadCell>
            <TableHeadCell
              class="f-center"
              style="
                --max-width-th: 2.5rem;
                --padding-th: 0;
                --overflow-th: none;
                border-top-left-radius: 4px;
              "
            >
              <TableMainCheckbox
                style="font-size: 1rem"
                :indeterminate="tcrud_mainCheckboxValue === 'indeterminate'"
                :value="tcrud_mainCheckboxValue === 'all'"
                @click="tcrud_toggleSelectedAll"
              />
            </TableHeadCell>
            <TableHeadCell
              class="f-center"
              style="
                --max-width-th: 2.5rem;
                --padding-th: 0;
                --overflow-th: none;
                border-top-left-radius: 4px;
              "
            >
            </TableHeadCell>
          </template>
        </TableHead>
      </template>
      <template #default="{ item, index }">
        <PracticeSessionsTableV2Row
          :thead="thead"
          :item="item"
          :isSelected="!!tcrud_selectedItems[index]"
          @toggle:selected="tcrud_toggleSelected(item, index, tcrud_items)"
          @toggle:marked="toggleMarked(item)"
          @click="detailItem = (detailItem ? detailItem.id : '') === item.id ? null : item"
        >
        </PracticeSessionsTableV2Row>
        <PracticeSessionsTableV2RowDetail
          v-if="detailItem ? detailItem.id === item.id : false"
          class="text-noselect"
          :item="item"
        />
      </template>
    </TableBody>

    <div class="f-center mt-1">
      <div
        class="gw_btn gw_btn_text text-medium weight_500 clr-grey mr-auto"
        @click="
          $store.dispatch(
            'router_set_dialogs',
            'table-columns-settings-dialog_table-practicesessions',
          )
        "
      >
        <div class="mdi mdi-pencil text-snormal mr-1"></div>
        {{ $t('btn.edit') }}
      </div>
      <GwPagination
        class="ml-auto"
        :limit="tcrud_limit"
        :offset="tcrud_offset"
        :hasNext="tcrud_hasNext"
        :loading="tcrud_loading"
        @update:pagination="tcrud_updatePagination"
      />
    </div>
  </div>
</template>

<script>
import TableDeleteBtns from '@/components/DataTables/TableDeleteBtns'
import IconAndText from '@/components/Poker/Overlays/IconAndText'
import GwFilter from '@/components/DataTables/Filters/new/GwFilter'
import TableFilterStar from '@/components/DataTables/Filters/TableFilterStar'
import { getTrainerClearQuery } from '@/helpers/trainer_presets'
import { getGameformat } from '@/store/gameformat/gameformat'
import { defaultTablesColumns } from '@/store/userSettings/settingsDefaults'
import TableHead from '@/components/DataTables/v2/TableHead'
import TableHeadCell from '@/components/DataTables/v2/TableHeadCell'
import TableBody from '@/components/DataTables/v2/TableBody'
import GwPagination from '@/components/lib/GwPagination/GwPagination'
import PracticeSessionsTableV2Row from '@/components/DataTables/v2/tables/PracticeSessionsTableV2/PracticeSessionsTableV2Row'
import PracticeSessionsTableV2RowDetail from '@/components/DataTables/v2/tables/PracticeSessionsTableV2/PracticeSessionsTableV2RowDetail'

import table_mix from '@/components/DataTables/table_mix'
import float_mix from '@/mixins/float_mix'
import tcrud_mix from '@/components/DataTables/tcrud_mix'

export default {
  name: 'PracticeSessionsTableV2',
  components: {
    TableHead,
    TableHeadCell,
    GwPagination,
    TableBody,
    PracticeSessionsTableV2Row,
    PracticeSessionsTableV2RowDetail,
    TableDeleteBtns,
    IconAndText,
    GwFilter,
    TableFilterStar,
  },
  mixins: [tcrud_mix, table_mix, float_mix],
  data() {
    this.tcrud_conf = {
      idKey: 'id',
      getEndpoint: item => `poker/practice/sessions/${item.id}/`,
      getBatchDeleteEndpoint: item => `poker/practice/sessions/batch-delete/`,
      apiVersion: 'v1',
      deleteSuccessMessage: 'messages.upload.sessions_deleted',
      deleteErrorMessage: 'analyze.upload.error_deleting_sessions',
    }

    this.tbl_persistSortKey = 'practicesessions_sort'

    this.tcrud_endpoint = 'poker/practice/sessions/'
    this.tcrud_mutation = 'api_practice_sessions'
    this.tcrud_apiVersion = 'v1'
    return {
      tbl_sortConf: {
        sortKey: 'created_at',
        sortOrder: 'desc',
      },
      selectedRows: [],
      lastTouchedIdx: -1,

      tcrud_limit: 100,
      tcrud_offset: 0,
      filterVisible: false,
      detailItem: null,
    }
  },
  created() {
    this.tbl_setSortConf()
  },
  methods: {
    toggleMarked(item) {
      const expected_item = {
        ...item,
        marked: !item.marked,
      }
      this.tcrud_patchItem({
        item,
        patchData: { marked: !item.marked },
        expected_item,
      })

      // this.$store.dispatch('poker_hand_history_hands_marked', item)
      this.updateDetailItem(expected_item)
    },
    updateDetailItem(item) {
      if (!this.$store.getters.globals_drawer.open) return
      this.$store.dispatch('globals_drawer', {
        id: 'trainer_hand_history_item',
        open: true,
        item,
        maximized: this.$store.getters.globals_drawer.maximized,
      })
    },
  },
  computed: {
    handDetailItem() {
      return this.$store.getters.globals_drawer?.item || {}
    },
    thead() {
      const cols = {
        created_at: {
          name: this.$t('table_head.date_played'),
          sortKey: 'created_at',
          width: 7,
        },
        format: {
          name: this.$t('table_head.format'),
          width: 5,
        },
        name: {
          name: this.$t('table_head.name'),
          width: 12,
        },
        hands: {
          name: this.$t('table_head.hands'),
          sortKey: 'total_hands',
        },
        gto_score: {
          name: this.$t('table_head.gto_score'),
          sortKey: 'gto_score_avg',
          width: 8,
        },
        ev_loss: {
          name: this.$t('table_head.ev_loss'),
          sortKey: 'total_ev_loss_sum',
          width: 8,
        },
        ev_loss_avg: {
          name: this.$t('table_head.ev_loss_avg'),
          sortKey: 'total_ev_loss_avg',
          width: 8,
        },
      }

      const colsOrder =
        this.$store.getters.tablesColumns.practicesessions ||
        defaultTablesColumns().practicesessions
      const res = {}
      Object.keys(cols).forEach(key => {
        if (colsOrder.includes(key)) {
          const col = cols[key]
          const colOrder = colsOrder.indexOf(key) + 1
          const width = col.width || 4
          res[key] = {
            ...col,
            cssStyle: `
            --min-width-th: ${width}rem;
            --max-width-th: ${width}rem;
            order: ${colOrder};`,
            tdStyle: `
            --min-width-td: ${width}rem;
            --max-width-td: ${width}rem;
            order: ${colOrder}`,
          }
        }
      })
      return res
    },
    tcrud_apiData() {
      return this.$store.getters.api_get_data(this.tcrud_mutation)
    },
    tcrud_items() {
      const { gameformats } = this.$store.getters

      const res = (this.tcrud_apiData?.results || []).map(i => {
        const query = i.settings
        const fullQuery = getTrainerClearQuery(query)
        const gameformat = getGameformat({
          item: {
            depth: query.depth,
            stacks: query.stacks,
            gametype: query.gametype,
          },
          gameformats,
        })
        if (!gameformat?.group) {
          // console.log('gameformat not found', i, query)
          console.error('session--gmf-not-found--', {
            depth: query.depth,
            stacks: query.stacks,
            gametype: query.gametype,
          })
          // debugger
        }
        const r = {
          ...i,
          local_name: i.name
            ? i.name
            : i.format === 'Custom'
              ? 'Custom session'
              : this.$t('common.gameformat_session', {
                  gmf: gameformat
                    ? this.$t(`gametypes.groups.${gameformat.group}`)
                    : query.gametype,
                }),
          fullQuery,
          gameformat,
        }
        return r
      })
      return res
    },
    tcrud_hasNext() {
      return !!this.tcrud_apiData?.links?.next || !!this.tcrud_apiData?.next
    },
    tcrud_apiCall() {
      return this.$store.getters.api_get(this.tcrud_mutation)
    },
    tcrud_loading() {
      return this.tcrud_customLoading || this.tcrud_apiCall?.loading
    },
    tcrud_error() {
      return this.tcrud_apiCall?.error
    },
    filter() {
      return this.$store.getters.ffps
    },
    tcrud_params() {
      // console.log(this.tbl_sortConf, 'tbl_sortConf')
      const res = !this.filter.loaded
        ? {}
        : {
            ...(this.filter.params || {}),
            limit: this.tcrud_limit,
            offset: this.tcrud_offset,
            ordering: `${this.tbl_sortConf.sortOrder === 'desc' ? '-' : ''}${
              this.tbl_sortConf.sortKey
            }`,
          }
      // console.log(res, this.tbl_sortConf, 'tbl_sortConf')
      return res
    },
  },
}
</script>

<style lang="scss" scoped>
.tableddfiles {
  display: flex;
  min-height: 0;
  flex-direction: column;
  position: relative;
}
</style>
